import * as jsPDF from 'jspdf';
import ticketPDF from 'common/assets/ifeno_logo.png'
import findTicketDetailByIdUseCase from './detail/findTicketDetailByIdUseCase';
import findClientByTask from 'tasks/services/sign/findClientByTask';
import { pad, renderDate } from 'common/services/util';
import addFontConsolas from './addFontConsolasUseCase';
import { calculateTotalInvoice, calculateTotalItem } from 'invoices/services/detail/calculateInvoicesInfo';
import { storage } from 'common/config/Firebase';

const createPDFTicketUseCase = async ({ ticketData, initialTicketDetailData, operation, numberPhone, extraText = "" }) => {
    const { ticketDetailData, clientData } = await findAllData({ ticketData, ticketDetailData: initialTicketDetailData })

    const heightPDF = operation === "upload" ? 3003 : 3003
    const doc = new jsPDF('p', 'mm', [68, heightPDF])
    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();

    addFontConsolas(doc)
    doc.setFont("CONSOLAS")

    const imgTicket = new Image()
    imgTicket.src = ticketPDF
    const widthImage = width * 0.75
    const heightImage = widthImage / 3.58
    doc.addImage(imgTicket, 'PNG', (width - widthImage) / 2, (height * 0.01 - heightImage) / 2, widthImage, heightImage, '', 'FAST')

    preHeader({ doc, width, height })
    headerData({ doc, width, height, ticketData, clientData })
    const finalHeightProducts = productsData({ doc, width, height, ticketDetailData, ticketData })
    const finalHeightTotalData = totalData({ doc, width, height, heightInitial: finalHeightProducts, ticketData, ticketDetailData })
    infoData({ doc, width, height, heightInitial: finalHeightTotalData })

    if (operation === "print") {
        doc.autoPrint()
    }

    if (operation === "print" || operation === "view") {
        const blob = doc.output('blob');
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 100);
    }

    if (operation === "upload" || operation === "uploadEmail") {
        const clientDataPhone = clientData?.phone ? String(clientData.phone) : null;
        const rawPhone = (numberPhone || clientDataPhone || "").toString();
        const phone = rawPhone.replace(/\D/g, "");

        const safeName = (clientData?.name || "CLIENTE").trim();
        let nameFile = `${safeName}-TICKET-${pad(ticketData.numTicket, 5)}.pdf`.replace(/ /g, "_");

        const uri = doc.output('datauristring');
        const ref = storage.ref().child(nameFile);
        await ref.putString(uri, 'data_url');
        const url = await ref.getDownloadURL();

        const baseMsg =
            `Estimado cliente, le contactamos desde el Servicio Técnico de IFENO.\n` +
            `A través del siguiente enlace, podrá descargar su TICKET: ${url}`;

        const fullMsg = [baseMsg, extraText].filter(Boolean).join("\n\n");
        const encodedMsg = encodeURIComponent(fullMsg);

        // Copiar siempre al portapapeles
        try {
            await navigator.clipboard.writeText(fullMsg);
        } catch {
            const el = document.createElement('textarea');
            el.value = fullMsg;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        }

        if (operation === "upload") {
            if (!phone) {
                alert("El cliente no tiene teléfono, pero se ha copiado el mensaje.");
            } else {
                const isMobileDevice =
                    (typeof window.orientation !== "undefined") ||
                    (navigator.userAgent.indexOf('IEMobile') !== -1);

                if (isMobileDevice) {
                    const waUrl = `whatsapp://send?phone=34${phone}&text=${encodedMsg}`;
                    window.location.href = waUrl;
                } else {
                    window.open(`https://api.whatsapp.com/send?phone=34${phone}&text=${encodedMsg}`);
                }
            }
        }

        // En ambos casos (upload y uploadEmail) devolvemos la URL
        return url;
    }

    if (operation === "save") {
        doc.save(clientData.name + "-" + pad(ticketData.numTicket, 5) + ".pdf")
    }
}

const preHeader = ({ doc, width, height }) => {
    doc.setFontSize(3.5)
    const heightInitial = height * 0.01
    const added = 0.002
    doc.line(width * 0.02, heightInitial, width * 0.98, heightInitial)

    doc.text("IFENO MOBILE SOLUTIONS SL-B74459140", width / 2, heightInitial + height * added, { maxWidth: width, align: "center" })
    doc.text("C/FUERTES ACEVEDO 56, BAJO", width / 2, heightInitial + height * added * 2, { align: "center" })
    doc.text("33006, OVIEDO, ASTURIAS", width / 2, heightInitial + height * added * 3, { align: "center" })
    doc.text("info@ifeno.es - 985072053", width / 2, heightInitial + height * added * 4, { align: "center" })
}

const headerData = ({ doc, width, height, ticketData, clientData }) => {
    doc.setFontSize(3.1)
    const widthInfo = width * 0.3
    const widthText = width * 0.02
    const heightInitial = height * 0.022
    const added = 0.002

    doc.text("FECHA:", widthText, heightInitial)
    doc.text(renderDate(ticketData.ticketDate, true), widthInfo, heightInitial);

    doc.text("NºFACTURA:", widthText, heightInitial + height * added)
    doc.text(ticketData.numTicket + "", widthInfo, heightInitial + height * added)

    doc.text("CLIENTE:", widthText, heightInitial + height * added * 2)
    doc.text(clientData && clientData.name ? clientData.name.toUpperCase() : "", widthInfo, heightInitial + height * added * 2);

    doc.text("DNI/CIF:", widthText, heightInitial + height * added * 3)
    clientData && doc.text(clientData && clientData.id ? clientData.id : "", widthInfo, heightInitial + height * added * 3);

    doc.line(width * 0.02, heightInitial + height * added * 4, width * 0.98, heightInitial + height * added * 4)
}

const productsData = ({ doc, width, height, ticketDetailData, ticketData }) => {
    const heightInitial = height * 0.032
    doc.text("DESCRIPCIÓN", width * 0.02, heightInitial)
    doc.text("CANTIDAD", width * 0.75, heightInitial, { align: 'right' })
    doc.text("TOTAL", width * 0.98, heightInitial, { align: 'right' })

    const added = 0.0025
    const heightProducts = height * 0.034
    calculateTotalItem(ticketDetailData.data).forEach((data, index) => {
        let description = data.description || ""

        if (description.length > 50) {
            description = description.slice(0, 47) + "..."
        }

        doc.text(description, width * 0.02, heightProducts + index * height * added, { maxWidth: width * 0.65 })
        doc.text(renderNumber(data.units), width * 0.75, heightProducts + index * height * added, { align: 'right' })
        doc.text(renderNumberPrice(data.totalPrice, data.iva, ticketData.ivaPercent), width * 0.98, heightProducts + index * height * added, { align: 'right' })
    })

    return heightProducts + ticketDetailData.data.length * height * added
}

const totalData = ({ doc, width, height, heightInitial, ticketData, ticketDetailData }) => {
    const { base, total, ivaPrice } = calculateTotalInvoice(ticketDetailData.data, ticketData.ivaPercent)

    const widthText = width * 0.02
    doc.setFontSize(4.2)
    doc.setFont("CONSOLAS-bold")
    doc.text(`TOTAL`, widthText, heightInitial + height * 0.001, { align: 'left' })
    doc.text(`${renderPrice(total)} €`, width * 0.98, heightInitial + height * 0.001, { align: 'right' })

    doc.setFontSize(3.1)
    doc.setFont("CONSOLAS")
    doc.text(`IVA(${ticketData.ivaPercent || 21}%)`, widthText, heightInitial + height * 0.003, { align: 'left' })
    doc.text(`${renderPrice(ivaPrice)} €`, width * 0.98, heightInitial + height * 0.003, { align: 'right' })
    doc.text(`BASE IMPONIBLE`, widthText, heightInitial + height * 0.005, { align: 'left' })
    doc.text(`${renderPrice(base)} €`, width * 0.98, heightInitial + height * 0.005, { align: 'right' })

    const widthText2 = width * 0.35
    const clientPay = ticketData.moneyToPay
    doc.text("FORMA DE PAGO", widthText2, heightInitial + height * 0.008, { align: 'left' })
    doc.text(renderPaymentMode(ticketData.paymentMode), width * 0.98, heightInitial + height * 0.008, { align: 'right' })

    if (ticketData.paymentMode !== 2) {
        doc.line(width * 0.02, heightInitial + height * 0.01, width * 0.98, heightInitial + height * 0.01)
        return heightInitial + height * 0.01
    }

    doc.text("CLIENTE PAGA CON", widthText2, heightInitial + height * 0.01, { align: 'left' })
    doc.text(`${renderPrice(clientPay)} €`, width * 0.98, heightInitial + height * 0.01, { align: 'right' })

    doc.text("CAMBIO", widthText2, heightInitial + height * 0.012, { align: 'left' })
    doc.text(`${renderPrice(clientPay - total)} €`, width * 0.98, heightInitial + height * 0.012, { align: 'right' })

    doc.line(width * 0.02, heightInitial + height * 0.014, width * 0.98, heightInitial + height * 0.014)

    return heightInitial + height * 0.014
}

const infoData = ({ doc, width, height, heightInitial }) => {
    doc.text("¡GRACIAS POR CONFIAR EN NOSOTROS!", width / 2, heightInitial + height * 0.002, { align: "center" })
    doc.text("www.ifeno.es", width / 2, heightInitial + height * 0.004, { align: "center" })
    doc.setFontSize(2.7)
    doc.text(`CONDICIONES DE GARANTÍA – REPARACIONES Y VENTA

 REPARACIONES: Todas nuestras reparaciones tienen 3 meses de garantía según el art. 6 del RD 58/1988. Cubre solo la parte reparada y comienza desde la entrega. No cubre daños por golpes, torsión, humedad, líquidos, mal uso ni roturas de pantalla o cristal. Queda anulada si el equipo es manipulado por terceros.

 En dispositivos sellados (resistentes al agua), al abrirlos puede perderse la impermeabilización y aparecer microfisuras o daños visibles. Estos riesgos son asumidos por el cliente.

 Si el equipo tiene humedad o líquidos, pueden aparecer fallos nuevos no cubiertos. En reparaciones con microsoldadura puede dañarse la placa base; no nos hacemos responsables si ocurre.

 No nos hacemos responsables de la pérdida de datos del dispositivo. Se recomienda hacer copia de seguridad antes de cualquier reparación.

 Usamos repuestos originales o de alta calidad, aunque podrían anular la garantía oficial del fabricante.

 VENTA DE TERMINALES: Todos los terminales tienen 24 meses de garantía desde la fecha de compra. No se cubren daños por golpes, roturas de pantalla o tapa trasera, ni daños por líquidos, aunque el equipo sea estanco.

 La garantía queda anulada si el dispositivo ha sido manipulado por terceros o si presenta roturas visibles.
`,
        width / 2, heightInitial + height * 0.006, { maxWidth: width * 0.98, align: 'center' })
}

const findAllData = async ({ ticketData, ticketDetailData }) => {
    if (!ticketDetailData) {
        ticketDetailData = await findTicketDetailByIdUseCase(ticketData.id)
    }

    const clientData = ticketData.dniClient
        ? await findClientByTask(ticketData.dniClient)
        : {}

    return {
        ticketDetailData,
        clientData
    }
}

const renderNumber = (number) => {
    if (!number) {
        return "0"
    }

    return number + ""
}

const renderNumberPrice = (number, iva, numberIVA = 21) => {
    const ivaPercent = parseFloat(numberIVA) / 100
    number = number ? parseFloat(number) : 0
    number = iva ? number : number * (1 + ivaPercent)
    return `${number.toFixed(2).replace(".", ",")}`
}

const renderPrice = number => {
    if (!number) {
        return "0"
    }

    return Number(number).toFixed(2).replace(".", ",")
}

const renderPaymentMode = payment => {
    const mapPaymentMode = {
        0: "SIN PAGAR",
        1: "TARJETA",
        2: "EFECTIVO"
    }

    return mapPaymentMode[payment] || "SIN PAGAR"
}

export default createPDFTicketUseCase